import React from 'react';
import { Section } from '../ui/Section';
import { TestimonialCard } from '../ui/TestimonialCard';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín G.',
    role: 'Abogado, 34 años',
    content: 'Siempre sentí que me pasaban por arriba en las negociaciones. Con este sistema aprendí a plantar bandera sin ser agresivo. Mi facturación subió un 40% este mes.'
  }, {
    name: 'Sofía L.',
    role: 'Emprendedora, 29 años',
    content: 'Detecté que un proveedor me estaba mintiendo sobre los plazos gracias al módulo de microexpresiones. Me ahorré miles de dólares y un dolor de cabeza gigante.'
  }, {
    name: 'Andrés M.',
    role: 'Gerente de Ventas, 41 años',
    content: 'No es humo. Son herramientas tácticas. Lo apliqué en una reunión de directorio y por primera vez sentí que yo controlaba el ritmo de la charla.'
  }, {
    name: 'Valentina R.',
    role: 'Estudiante, 24 años',
    content: "Me costaba mucho poner límites en mis relaciones. El módulo de 'Control de Marcos' me cambió la vida. Ahora me respetan más."
  }, {
    name: 'Diego S.',
    role: 'Consultor, 38 años',
    content: "Directo al grano. Sin vueltas. Si querés dejar de ser el 'buenudo' del grupo, necesitás leer esto hoy mismo."
  }];
  return <Section className="bg-zinc-950" data-id="element-228">
      <div className="text-center mb-16" data-id="element-229">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-230">
          Resultados Reales
        </h2>
        <p className="text-zinc-400" data-id="element-231">
          Personas comunes que recuperaron su poder social.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-232">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-233" />)}
      </div>
    </Section>;
}